import { CurrencyType, serverCurrencyToSystemCurrency } from '@wolffun/system-currency';
import { createSelectorHook, useDispatch } from 'react-redux';

/** Typed selector */
export const useTypedSelector = createSelectorHook();
/** Typed dispatcher */

export const useTypedDispatch = useDispatch;
export const parseVestingSafeConfigResponse = data => {
  const {
    minPaid,
    secondClaimFee,
    paidAfter
  } = data || {};
  return {
    minPaid: serverCurrencyToSystemCurrency(minPaid),
    secondClaimFee: typeof secondClaimFee === 'number' ? secondClaimFee : 0,
    paidAfter: typeof paidAfter === 'number' ? paidAfter : 0
  };
};
export const parseVestingSafe = data => {
  const {
    id,
    created,
    gTHG
  } = data || {};
  return {
    id: typeof id === 'string' ? id : '',
    amountTotal: gTHG !== null && gTHG !== void 0 && gTHG.amountTotal ? serverCurrencyToSystemCurrency(gTHG.amountTotal) : {
      token: CurrencyType.GTHG,
      value: ''
    },
    claimable: gTHG !== null && gTHG !== void 0 && gTHG.claimable ? serverCurrencyToSystemCurrency(gTHG.claimable) : {
      token: CurrencyType.GTHG,
      value: ''
    },
    maxPaid: gTHG !== null && gTHG !== void 0 && gTHG.max ? serverCurrencyToSystemCurrency(gTHG.max) : {
      token: CurrencyType.GTHG,
      value: ''
    },
    fee: gTHG !== null && gTHG !== void 0 && gTHG.fee ? serverCurrencyToSystemCurrency(gTHG.fee) : {
      token: CurrencyType.GTHG,
      value: ''
    },
    released: gTHG !== null && gTHG !== void 0 && gTHG.released ? serverCurrencyToSystemCurrency(gTHG.released) : {
      token: CurrencyType.GTHG,
      value: ''
    },
    created: typeof created === 'string' ? created : '',
    dailyGTHGVestingPercent: typeof (gTHG === null || gTHG === void 0 ? void 0 : gTHG.dailyGTHGVesting) === 'number' ? gTHG.dailyGTHGVesting * 100 : 0
  };
};